import React from "react"

export const Status = ({ variant, text }) => {
  // status : warning, need-ba, completed
  return <div className={`status-text ${variant}`}>{text}</div>
}
